import { render, staticRenderFns } from "./widgetFormItem.vue?vue&type=template&id=81657880&scoped=true&"
import script from "./widgetFormItem.vue?vue&type=script&lang=js&"
export * from "./widgetFormItem.vue?vue&type=script&lang=js&"
import style0 from "./widgetFormItem.vue?vue&type=style&index=0&id=81657880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81657880",
  null
  
)

export default component.exports